
import {Options, Vue} from 'vue-class-component'; // @ is an alias to /src

@Options({components: {}})
export default class Home extends Vue
{

}
